import * as types from '../types'

export default {
  state: {
    cachedComponents: []
  },
  mutations: {
    [types.ADD_CACHED_COMPONENTS]: (state, name) => {
      const cached = [];
      let has = false;
      for (let i = 0; i < state.cachedComponents.length; i++) {
        if (state.cachedComponents[i] === name) {
          has = true;
          break;
        }
      }
      if (!has) {
        cached.push(name)
        state.cachedComponents = state.cachedComponents.concat(cached).slice();
      }
    },
    [types.DEL_CACHED_COMPONENTS]: (state, name) => {
      state.cachedComponents = state.cachedComponents.filter(component => {
        return component !== name;
      })
    }
  },
  actions: {
    /**
     * 添加需要缓存的组件名称
     */
    AddCachedComponent: ({ commit }, name) => {
      commit(types.ADD_CACHED_COMPONENTS, name)
    },
    /**
     * 删除已经缓存的组件名称
     */
    DelCachedComponent: ({ commit }, name) => {
      commit(types.DEL_CACHED_COMPONENTS, name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cacheComs.js